import {
  Check,
  CheckCircle,
  Envelope,
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  Phone,
  PushPinSimple,
  WarningCircle,
} from '@phosphor-icons/react'
import React, { useState } from 'react'
import ContactBackground from '../../assets/images/Contact/ContactImage.svg'
import PrevixLogo from '../../assets/images/Contact/PrevixLogoHorizontalDescription.svg'
import {
  Body,
  CheckboxAppearence,
  CheckboxInput,
  CheckboxLabel,
  Container,
  FooterContainer,
  FooterInfos,
  FooterLine,
  FooterMap,
  FooterMapCanva,
  FooterSection,
  FooterSocialMediaIcon,
  FooterTitle,
  Form,
  FormButtonContainer,
  FormCheckboxContainer,
  FormContainer,
  FormRow,
  FormTextArea,
  FormTitle,
  Header,
  ImageBackground,
  LogoContainer,
} from './styles'

export const Privacity = () => {
  return (
    <Container>
      <Header>
        <LogoContainer>
          <img src={PrevixLogo} alt="Previx logo" />
        </LogoContainer>
      </Header>
      <Body>
        <ImageBackground src={ContactBackground} />
        <FormContainer>
          <h3>1 - Guia e informativo de políticas de privacidade</h3>
          {'\n'}
          <p>
            Este documento tem o objetivo de garantir a transparência e a
            segurança no tratamento dos dados pessoais, assegurando que os
            usuários estejam cientes de seus direitos e de como suas informações
            estão sendo utilizadas pela nossa empresa, fornecedores, parceiros e
            colaboradores.
          </p>
          {'\n'}
          <h4>Objetivos da política de privacidade</h4>
          {'\n'}
          <p>
            O objetivo da política de privacidade do aplicativo é proteger a
            privacidade dos nossos usuários, garantindo que os dados pessoais e
            locais sejam tratados com responsabilidade e confidencialidade.
            {'\n'} {'\n'}
            Nossa política de privacidade está destinada a informar os usuários
            sobre como coletamos, usamos e compartilhamos seus dados, bem como
            as medidas que tomamos para proteger a segurança dos dados. Além
            disso, nossa política de privacidade é baseada nos princípios da
            transparência, responsabilidade e confidencialidade, garantindo que
            os usuários tenham controle sobre seus dados e sejam notificados em
            caso de alterações à política.
          </p>
          {'\n'}
          <h3>2 - Coleta de dados</h3>
          {'\n'}
          <h4>Tipos de dados coletados</h4>
          {'\n'}
          <p>
            Os dados são coletados para garantir um trajeto seguro e tranquilo,
            oferecendo proteção em situações emergenciais e monitoramento
            constante, conforme descrito nos objetivos do PX One - Morador. A
            coleta e uso desses dados são essenciais para oferecer um serviço de
            alta qualidade e assegurar a proteção dos nossos usuários. O
            aplicativo coleta os seguintes tipos de dados:
          </p>
          {'\n'}
          <h4>Dados pessoais</h4>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nome: Utilizado para identificação
              e personalização dos serviços.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Endereço: Necessário para definir o
              ponto de chegada e monitorar a proximidade da residência
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Veículo e Placa do Veículo:
              Utilizados para identificação do meio de transporte e associá-lo
              ao usuário.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Moradores Cadastrados: Informações
              sobre outros moradores para garantir a segurança de todos nas
              ocorrências.
            </li>
          </ul>
          {'\n'}
          <h4>Localização</h4>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp; Localização baseada em GPS: Usada para
              acompanhar o trajeto do usuário e da escolta de segurança em tempo
              real.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp; Localização baseada em redes W-ifi ou
              torres de celular: Utilizada como apoio à localização GPS para
              melhorar a precisão.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp; Localização em segundo plano:
              Monitoramento contínuo para envio de notificações sobre a entrada
              e saída do raio de 3 km da residência e para monitoramento em caso
              de acionamento do botão de pânico.
            </li>
          </ul>
          {'\n'}
          <h4>Câmera</h4>
          {'\n'}
          <p>
            Foto de Perfil: Utilizada para tirar e atualizar a foto de perfil do
            usuário, facilitando a identificação
          </p>
          {'\n'}
          <h4>Gravação de áudio</h4>
          {'\n'}
          <p>
            O aplicativo PX One - Morador solicita permissão para acesso ao
            áudio do seu dispositivo. É importante destacar que essa permissão é
            necessária devido ao uso da biblioteca expo-camera, que utilizamos
            para a atualização da sua foto de perfil. Embora o áudio não seja
            diretamente utilizado para as funcionalidades principais do
            aplicativo, a permissão é requerida pela biblioteca para assegurar o
            funcionamento correto da captura e atualização de imagens de perfil.
          </p>
          {'\n'}
          <h4>Finalidade de coletas de dados</h4>
          {'\n'}
          <p>
            Os dados são coletados e processados com o objetivo de oferecer
            segurança e proteção aos usuários em seu trajeto residencial,
            incluindo a garantia de um trajeto seguro e tranquilo com ajuda de
            escoltas de segurança qualificados, monitoramento constante da
            localização da escolta e visualização do trajeto no mapa. Além
            disso, esses dados são utilizados para oferecer informações em tempo
            real sobre a entrada e saída do raio de 3km da residência cadastrada
            e atualizações constantes sobre o trajeto da escolta.
          </p>
          {'\n'}
          <h4>Uso e compartilhamento de dados</h4>
          {'\n'}
          <h5>Como os dados são utilizados dentro do aplicativo</h5>
          {'\n'}
          <p>
            Os dados coletados pelo PX One - Morador são utilizados de diversas
            maneiras para garantir a segurança e a eficiência dos serviços
            oferecidos. Aqui está uma descrição de como cada tipo de dado é
            utilizado dentro do aplicativo:
          </p>
          {'\n'}
          <h5>Dados pessoais</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nome: Utilizado para personalizar a
              experiência do usuário e permitir a identificação rápida em caso
              de suporte ou emergência.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Endereço: Necessário para definir o
              ponto de chegada e monitorar a proximidade da residência,
              permitindo que o usuário receba notificações ao entrar ou sair do
              raio de 3 km da sua residência.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Veículo e Placa do Veículo:
              Utilizados para identificar o meio de transporte do usuário e
              associar essa informação aos serviços de segurança oferecidos.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Moradores Cadastrados: As
              informações sobre outros moradores são utilizadas para garantir a
              segurança de todos no domicílio e permitir uma gestão eficiente
              dos serviços de escolta e monitoramento.
            </li>
          </ul>
          {'\n'}
          <h5>Localização</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Localização baseada em GPS:
              Utilizada para acompanhar o trajeto do usuário em tempo real,
              fornecendo atualizações constantes sobre o percurso e a
              localização da escolta de segurança.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Localização baseada em redes Wi-fi
              ou torres de celular: Serve como apoio para melhorar a precisão da
              localização, garantindo que o monitoramento seja confiável mesmo
              em áreas com sinal de GPS fraco.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Localização em segundo plano:
              Utilizada para monitorar continuamente a posição do usuário,
              enviar notificações sobre a entrada e saída do raio de 3 km da
              residência e ativar alertas em caso de acionamento do botão de
              pânico
            </li>
          </ul>
          {'\n'}
          <h5>Câmera</h5>
          {'\n'}
          <p>
            Foto de Perfil: A câmera é utilizada para capturar e atualizar a
            foto de perfil do usuário, facilitando a identificação e
            personalização dentro do aplicativo.
          </p>
          {'\n'}
          <h5>Gravação de áudio</h5>
          {'\n'}
          <p>
            Ressaltamos que, embora a permissão de acesso ao áudio seja
            solicitada, o aplicativo não realiza gravações de áudio sem o seu
            consentimento explícito e não utiliza o áudio capturado para outras
            finalidades além das mencionadas. Estamos comprometidos em proteger
            sua privacidade e garantir que suas informações pessoais sejam
            tratadas com o máximo cuidado e respeito. Esses dados são essenciais
            para fornecer um serviço de alta qualidade e assegurar que os
            usuários do PX One - Morador tenham um trajeto seguro até suas
            residências, proteção em situações emergenciais e monitoramento
            constante durante todo o percurso.
          </p>
          {'\n'}
          <h3>3 - Compartilhamento de dados com terceiros</h3>
          {'\n'}
          <p>
            O aplicativo &ldquo;PX One - Morador&rdquo; compromete-se a proteger
            a privacidade dos nossos usuários, garantindo que os dados pessoais
            e locais sejam tratados com responsabilidade e confidencialidade.
          </p>
          {'\n'}
          <p>
            <strong>Nossos Fornecedores de Serviços:</strong> Nossos
            Fornecedores de Serviços:ós podemos compartilhar informações com
            nossos fornecedores de serviços para que eles possam fornecer apoio
            e proteção aos usuários. Esses fornecedores são obrigados a manter a
            confidencialidade dos dados e não podem utilizá-los para fins
            próprios.
          </p>
          {'\n'}
          <p>
            <strong>Autoridades Legítimas:</strong> Nós podemos compartilhar
            informações com autoridades legítimas, como órgãos de justiça ou
            agências governamentais, desde que haja uma ordem judicial válida ou
            outro requisito legal aplicável.
          </p>
          {'\n'}
          <p>
            <strong>Parceiros e Colaboradores: </strong> Nós podemos
            compartilhar informações com nossos parceiros e colaboradores para
            fins específicos, como a oferta de serviços complementares ou a
            melhoria da experiência do usuário.
          </p>
          {'\n'}
          <h5>Restrições para uso e compartilhamento de dados</h5>
          {'\n'}
          <p>
            No PX One - Morador, a privacidade e a segurança dos seus dados são
            nossas prioridades. Portanto, estabelecemos rigorosas restrições
            para o uso e compartilhamento das informações coletadas:
          </p>
          {'\n'}
          <h5>Uso interno limitado</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Os dados coletados são utilizados
              exclusivamente para fornecer e melhorar os serviços descritos em
              nossa Política de Privacidade.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Somente os funcionários e parceiros
              autorizados que necessitam dessas informações para desempenhar
              suas funções terão acesso aos dados.
            </li>
          </ul>
          {'\n'}
          <h5>Compartilhamento com terceiros</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Não compartilhamos seus dados
              pessoais com terceiros, exceto conforme necessário para fornecer
              nossos serviços, cumprir obrigações legais ou proteger nossos
              direitos. Quando compartilhamos dados com parceiros de serviço,
              exigimos que eles mantenham a confidencialidade e protejam suas
              informações com o mesmo nível de cuidado que nós.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Não vendemos, alugamos ou trocamos
              suas informações pessoais com terceiros para fins de marketing.
            </li>
          </ul>
          {'\n'}
          <h5>Exigências legais</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Poderemos divulgar suas informações
              pessoais caso sejamos obrigados por lei ou por ordem judicial, ou
              se acreditarmos de boa-fé que a divulgação é necessária para
              proteger nossos direitos, sua segurança ou a segurança de
              terceiros, investigar fraudes ou responder a uma solicitação
              governamental.
            </li>
          </ul>
          {'\n'}
          <h5>Segurança dos dados</h5>
          {'\n'}
          <ul>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Implementamos medidas de segurança
              técnicas e organizacionais adequadas para proteger seus dados
              contra acesso não autorizado, alteração, divulgação ou destruição.
              Consulte a Sessão 4 para mais detalhes.
            </li>
            <li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Apesar de nos esforçarmos para
              proteger suas informações, nenhum sistema de segurança é
              infalível. Portanto, não podemos garantir a segurança absoluta de
              seus dados, mas fazemos o máximo para garantir um alto nível de
              segurança.
            </li>
          </ul>
          {'\n'}
          <h3>4 - Segurança de dados</h3>
          {'\n'}
          <h4>
            Medidas de seguranças implementadas para garantir a integridade dos
            dados
          </h4>
          {'\n'}
          <p>
            O aplicativo PX One - Morador adota medidas robustas para proteger a
            segurança e integridade dos dados dos usuários. Essas medidas
            incluem:
          </p>
          {'\n'}
          <p>
            <strong>Criptografia: </strong> Os dados são criptografados para
            garantir que sejam impossíveis de serem lidos ou modificados sem
            permissão.
          </p>
          {'\n'}
          <p>
            <strong>Segurança da rede:</strong> A comunicação com o servidor é
            criptografada e realizada através de conexões seguras (HTTPS).
          </p>
          {'\n'}
          <p>
            <strong>Armazenamento seguro:</strong> Os dados são armazenados em
            servidores seguros, protegidos por firewalls e sistemas de detecção
            de intrusão.
          </p>
          {'\n'}
          <p>
            <strong>Controle de acesso:</strong> Acesso restrito a apenas
            aqueles que têm necessidade de conhecimento ou modificação dos
            dados.
          </p>
          {'\n'}
          <h4>
            Treinamento regular do pessoal responsável pelo tratamento dos dados
          </h4>
          {'\n'}
          <p>
            A equipe responsável pelo tratamento dos dados é treinada
            regularmente para garantir que sigam as políticas de segurança e
            privacidade internas
          </p>
          {'\n'}
          <p>
            Além disso, o aplicativo segue as melhores práticas de segurança e
            proteção de dados estabelecidas pelas autoridades reguladoras e
            associações de tecnologia. Estamos comprometidos em manter a
            segurança dos dados dos usuários e trabalhar constantemente para
            melhorar nossas medidas de segurança
          </p>
          {'\n'}
          <h3>5 - Alterações da política de privacidade</h3>
          {'\n'}
          <h4>Quando a política de privacidade pode ser alterada</h4>
          {'\n'}
          <p>
            A política de privacidade do PX One- Morador pode ser alterada a
            qualquer momento e sem aviso prévio, seja por razões técnicas,
            legais ou comerciais. As alterações serão publicadas e estarão
            disponíveis para consulta dos usuários. É importante que os usuários
            revisitem periodicamente a política de privacidade para ficarem
            cientes das alterações e concordarem com as novas condições.
          </p>
          {'\n'}
          <h4>Como os usuários serão notificados em caso de alteração</h4>
          {'\n'}

          <p>
            Se a política de privacidade for modificada, você será notificado
            por meio de uma mensagem dentro do aplicativo (Neste caso é
            necessário que as notificações estejam ativas para ser notificado)
            ou por email (desde que o e-mail esteja válido).
          </p>
          {'\n'}

          <h4>Opções para consentimento ou negação da alteração</h4>
          {'\n'}

          <p>
            Se você não concordar com os termos das alterações nesta Política de
            Privacidade, recomendamos que você pare imediatamente de usar nosso
            aplicativo.
          </p>
          {'\n'}

          <p>
            Para esclarecer quaisquer dúvidas ou preocupações sobre as mudanças,
            entre em contato conosco através dos canais de atendimento da
            Previx.
          </p>
          {'\n'}

          <p>
            Estamos disponíveis para fornecer mais informações e discutir suas
            preocupações para garantir que você esteja plenamente ciente de como
            suas informações estão sendo tratadas.
          </p>
          {'\n'}

          <h3>6 - Contato e apoio</h3>
          {'\n'}

          <h4>
            Contato para perguntas ou preocupações sobre a política de
            privacidade
          </h4>
          {'\n'}

          <p>
            Se você tiver quaisquer perguntas ou preocupações sobre nossa
            Política de Privacidade, não hesite em nos contatar.
          </p>
          {'\n'}

          <p>
            Estamos aqui para ajudar e esclarecer todas as suas dúvidas. Você
            pode nos contatar através do seguinte e-mail:
          </p>
          <span>falecom@grupoprevix.com.br</span>
          {'\n'}
          {'\n'}

          <p>
            Alternativamente, você pode visitar nosso site e acessar a seção de
            contato diretamente através deste{' '}
          </p>
          <span>https://previx.ubicuacloud.com.br/contato</span>
          {'\n'}
          {'\n'}

          <h3>7 - Informações adicionais</h3>
          {'\n'}

          <h4>Encorajamento para lera a política de privacidade</h4>
          {'\n'}

          <p>
            Nós, da Previx, valorizamos sua privacidade e queremos garantir que
            você esteja plenamente informado sobre como coletamos, utilizamos e
            protegemos suas informações. Recomendamos fortemente que você leia
            esta Política de Privacidade com atenção. Ela contém detalhes
            importantes sobre seus direitos e obrigações, bem como as medidas
            que tomamos para garantir a segurança de seus dados pessoais.
          </p>
          {'\n'}

          <p>
            Ao compreender nossas práticas de privacidade, você pode tomar
            decisões informadas sobre o uso do nosso aplicativo{' '}
            <strong>PX One - Morador</strong> e aproveitar todos os benefícios
            que ele oferece com a confiança de que suas informações estão sendo
            tratadas com o máximo cuidado e respeito.{' '}
          </p>
          {'\n'}

          <p>
            Se tiver alguma dúvida ou precisar de mais esclarecimentos, não
            hesite em entrar em contato conosco.
          </p>
          {'\n'}
        </FormContainer>
      </Body>
      <FooterContainer>
        <FooterSection>
          <FooterTitle>MAIS INFORMAÇÕES</FooterTitle>
          <FooterInfos>
            <FooterLine>
              <PushPinSimple size={12} weight="fill" />
              <p>Av. Queiroz Filho, 917 - Vila Hamburguesa - São Paulo - SP</p>
            </FooterLine>
            <FooterLine>
              <Phone size={12} weight="fill" />
              <p>(11) 3875-1148</p>
            </FooterLine>
            <FooterLine>
              <Phone size={12} weight="fill" />
              <p>0800 515 0000 (SAC 24 Horas)</p>
            </FooterLine>
            <FooterLine>
              <Envelope size={12} />
              <p>previx@grupoprevix.com.br</p>
            </FooterLine>
          </FooterInfos>
          <FooterTitle>REDES SOCIAIS</FooterTitle>
          <FooterLine>
            <FooterSocialMediaIcon>
              <FacebookLogo size={32} weight="fill" />
            </FooterSocialMediaIcon>
            <FooterSocialMediaIcon>
              <InstagramLogo size={32} />
            </FooterSocialMediaIcon>
            <FooterSocialMediaIcon>
              <LinkedinLogo size={32} weight="fill" />
            </FooterSocialMediaIcon>
          </FooterLine>
        </FooterSection>
        <FooterSection>
          <FooterTitle>ONDE ESTAMOS</FooterTitle>
          <FooterMap>
            <FooterMapCanva>
              <iframe
                width="600"
                height="165"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=Av.%20Queiroz%20Filho%2C%20917%20-%20Vila%20Hamburguesa%20-%20S%C3%A3o%20Paulo%20-%20SP&t=&z=13&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
              ></iframe>
              <a href="http://vin-odometer.info">vin-odometer.info</a>
              <a href="https://embedmaps.info">Embed Google Maps</a>
            </FooterMapCanva>
          </FooterMap>
        </FooterSection>
      </FooterContainer>
    </Container>
  )
}
